import { CollaborationListItemFragment } from '../queries/ListingCollaborations.generated';

export function isPastCollaboration(c: CollaborationListItemFragment): boolean {
    const currentDate = new Date();
    const creationDate = new Date(c.createdAt);

    const diffTime = currentDate.getTime() - creationDate.getTime();
    const milliSecondsInDay = 1000 * 60 * 60 * 24;
    const diffDays = Math.floor(diffTime / milliSecondsInDay);

    return (
        diffDays > 60 ||
        ((c.status === 'COLLABORATION_STATUS_CANCELLED' ||
            c.status === 'COLLABORATION_STATUS_CLOSED') &&
            diffDays > 1)
    );
}
